import { TAGS_CRUD_ACTION_CREATORS } from '../actions/tags_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';
import { TagEntityType } from '../types/tags';

export const tagsRestCrudThunksForSupplier = new RestCrudThunks(
	'tags',
	'tag',
	'tag',
	'tags',
	TAGS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false
);

export const tagsOnPartsRestCrudThunksForSupplier = new RestCrudThunks(
	'part_tags',
	'tag',
	'tag',
	'part_tags',
	TAGS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

const fetchUtils = new FetchUtils();

export const associateTagsWithEntity =
	(roleType: string) =>
	(targetCollectionName: TagEntityType, entityId: number, tagIds: number[]) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/inventory/parts/${entityId}/tags`;

		return (dispatch) => {
			return new Promise<any>((resolve, reject) => {
				fetchUtils
					.put(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { ids: tagIds },
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((error) => {
						console.error('Error associating tags:', error);
						reject(error);
					});
			});
		};
	};
